import { 
 Palette, Code, Replace, PenLine, Layers, ShieldCheck, 
    Cpu, Database, Briefcase, Globe, ShoppingCart, Gauge, Smartphone, Cloud, Search, Brush, Settings
  } from 'lucide-react';
  

export const services = [
    {
      icon: <Palette className="w-8 h-8" />,
      title: "Custom Design Development",
      description: "Tailor-made template modifications to match your brand identity",
      features: ["Color scheme customization", "Layout restructuring", "Component redesign", "Brand element integration"],
    },
    {
      icon: <Code className="w-8 h-8" />,
      title: "Professional Installation",
      description: "Seamless template deployment with optimal configuration",
      features: ["CMS integration", "Hosting setup", "Database configuration", "Performance optimization"],
    },
    {
      icon: <Replace className="w-8 h-8" />,
      title: "Asset Replacement Service",
      description: "Complete media overhaul for your templates",
      features: ["Stock photo replacement", "Icon set customization", "Vector graphic redesign", "3D element integration"],
    },
    {
      icon: <PenLine className="w-8 h-8" />,
      title: "Strategic Copywriting",
      description: "Compelling content that converts visitors",
      features: ["SEO-optimized text", "Brand voice development", "Legal compliance review", "Multilingual adaptation"],
    },
    {
      icon: <Layers className="w-8 h-8" />,
      title: "Branding Integration",
      description: "Full brand ecosystem implementation",
      features: ["Style guide development", "Email template design", "Social media kit creation", "Print material adaptation"],
    },
    {
      icon: <ShieldCheck className="w-8 h-8" />,
      title: "Ongoing Support",
      description: "Continuous improvement and maintenance",
      features: ["Security updates", "Feature additions", "Performance monitoring", "Priority troubleshooting"],
    },
    {
      icon: <Cpu className="w-8 h-8" />,
      title: "API Development",
      description: "Custom API solutions for seamless integration",
      features: ["RESTful API design", "GraphQL implementation", "Third-party integrations", "Documentation & testing"],
    },
    {
      icon: <Database className="w-8 h-8" />,
      title: "Database Architecture",
      description: "Optimized data management solutions",
      features: ["SQL/NoSQL design", "Data modeling", "Migration services", "Security protocols"],
    },
    {
      icon: <Briefcase className="w-8 h-8" />,
      title: "Portfolio Design",
      description: "Professional showcase of your work",
      features: ["Interactive galleries", "Case study layouts", "Client testimonials", "Responsive displays"],
    },
    {
      icon: <Globe className="w-8 h-8" />,
      title: "Custom Websites",
      description: "Bespoke web development from scratch",
      features: ["Custom CMS development", "Interactive features", "Multilingual support", "Accessibility compliance"],
    },
    {
      icon: <ShoppingCart className="w-8 h-8" />,
      title: "E-commerce Solutions",
      description: "Complete online store development",
      features: ["Payment gateway integration", "Inventory management", "Shopping cart systems", "POS integration"],
    },
    {
      icon: <Gauge className="w-8 h-8" />,
      title: "Performance Optimization",
      description: "Lightning-fast website experiences",
      features: ["Core Web Vitals optimization", "Caching strategies", "Image optimization", "CDN configuration"],
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: "Mobile App Development",
      description: "Native and cross-platform applications",
      features: ["iOS/Android development", "Progressive Web Apps", "Push notifications", "App store optimization"],
    },
    {
      icon: <Cloud className="w-8 h-8" />,
      title: "Cloud Integration",
      description: "Scalable cloud infrastructure setup",
      features: ["AWS/Azure configuration", "Serverless architecture", "Cloud storage solutions", "Disaster recovery"],
    },
    {
      icon: <Search className="w-8 h-8" />,
      title: "SEO Services",
      description: "Search engine dominance strategy",
      features: ["Keyword research", "Technical SEO audit", "Content strategy", "Ranking monitoring"],
    },
    {
      icon: <Brush className="w-8 h-8" />,
      title: "UX/UI Audit",
      description: "User experience optimization",
      features: ["Heatmap analysis", "Conversion rate optimization", "Prototyping", "A/B testing"],
    },
    {
      icon: <Settings className="w-8 h-8" />,
      title: "Maintenance Plans",
      description: "Proactive website management",
      features: ["Weekly backups", "Uptime monitoring", "Software updates", "Emergency support"],
    }
  ];